<svg class="app_icon" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.551938 17L5.25594 9.176L0.551938 0.68H4.22394L7.24794 6.68L10.3439 0.68H13.7759L9.07194 9.008L13.7759 17H10.1039L7.07994 11.36L3.98394 17H0.551938Z" fill="#00B483"/>
</svg>